<template>
    <div class="col-md-12">
        <div class="field pull-right">
            <div class="control">
                <button v-if="relatedContacts.length" class="btn btn-primary" title="Add Existing Contact" type="button" @click="openModal">
                    <span class="icon"><i class="fas fa-search"></i></span><span> Add Exiting Contact</span>
                </button>
                <button class="btn btn-success" title="Add New Contact" type="button" @click="addNew">
                    <span class="icon"><i class="fas fa-plus"></i></span><span> Add New Contact</span>
                </button>
            </div>
        </div>
        <br>
        <br>
        <hr>
        <table v-cloak v-if="data.length" class="table is-narrow is-striped is-fullwidth">
            <thead>
                <tr>
                    <th>Type</th>
                    <th>Name</th>
                    <th>Company</th>
                    <th>Email</th>
                    <th>Phone</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(item, key) in data">
                    <td>
                        <select v-model="item.type" :name="'contacts[' + key + '][type]'" class="form-control" required>
                            <option value="primary">Primary Contact</option>
                            <option value="billing">Billing Contact</option>
                            <option value="design">Design Contact</option>
                        </select>
                    </td>
                    <td>
                        <input v-model="item.name" :name="'contacts[' + key + '][name]'" class="form-control" required type="text">
                    </td>
                    <td>
                        <input v-model="item.company" :name="'contacts[' + key + '][company]'" class="form-control" required type="text">
                    </td>
                    <td>
                        <input v-model="item.email" :name="'contacts[' + key + '][email]'" class="form-control" required type="email">
                    </td>
                    <td>
                        <input v-model="item.phone" :name="'contacts[' + key + '][phone]'" class="form-control" required type="text">
                    </td>
                    <td style="padding: 2px;">
                        <button class="btn btn-danger" title="Remove Contact" type="button" @click="remove(key)">
                            <span class="icon"><i class="fas fa-trash"></i></span>
                        </button>
                        <input v-model="item.id" :name="'contacts[' + key + '][id]'" type="hidden">
                    </td>
                </tr>
            </tbody>
        </table>
        <div v-cloak v-else>
            <p>No Contacts Found. <a href="javascript:" @click="addNew">Add One Now</a></p>
        </div>
        <div id="contactSearchModal" class="modal fade">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <button aria-hidden="true" class="close" data-dismiss="modal"
                            type="button">&times;
                        </button>
                        <h4 class="modal-title">Add Existing Contacts</h4>
                    </div>

                    <div class="modal-body">
                        <table v-cloak v-if="relatedContacts.length" class="table is-narrow is-striped is-fullwidth">
                            <thead>
                                <tr>
                                    <th>Type</th>
                                    <th>Agency/Advertiser</th>
                                    <th>Name</th>
                                    <th>Phone</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in relatedContacts">
                                    <td><span v-html="types[item.type]"></span></td>
                                    <td><span v-html="findRelationName(item)"></span></td>
                                    <td><span v-html="item.name"></span></td>
                                    <td><span v-html="item.phone"></span></td>
                                    <td style="padding: 2px;">
                                        <button class="btn btn-success" title="Remove Contact" type="button" @click="addExisting(item)">
                                            <span class="icon"><i class="fas fa-plus"></i></span>
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div class="modal-footer">
                        <button class="btn btn-default" data-dismiss="modal" type="button">Close</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    const emptyContact = {
        id: null,
        name: null,
        type: 'primary',
        company: null,
        email: null,
        phone: null
    };

    export default {
        name: 'AdvertisingContacts',
        props: {
            data: {
                type: Array,
                default() {
                    return [];
                }
            },
            relatedContacts: {
                type: Array,
                default() {
                    return [];
                }
            },
            relations: {
                type: Object,
                default() {
                    return {};
                }
            }
        },
        data() {
            return {
                types: {
                    primary: 'Primary Contact',
                    billing: 'Billing Contact',
                    design: 'Design Contact'
                }
            };
        },
        methods: {
            openModal() {
                $('#contactSearchModal').modal('show');
            },
            addExisting(item) {
                let contact = structuredClone(emptyContact);
                contact.name = item.name;
                contact.type = item.type;
                contact.company = item.company;
                contact.phone = item.phone;
                contact.email = item.email;
                this.data.push(structuredClone(contact));
                this.$nextTick(() => {
                    this.$forceUpdate();
                });
            },
            addNew() {
                this.data.push(structuredClone(emptyContact));
                this.$nextTick(() => {
                    this.$forceUpdate();
                });
            },
            remove(index) {
                if(confirm('Are you sure you want to remove this contact?')) {
                    this.$delete(this.data, index);
                    this.$nextTick(() => {
                        this.$forceUpdate();
                    });
                }
            },
            findRelationName(item) {
                let name = 'N/A';

                if(item.advertiser_id && this.relations[item.advertiser_id]) {
                    name = this.relations[item.advertiser_id];
                }

                if(item.agency_id && this.relations[item.agency_id]) {
                    name = this.relations[item.agency_id];
                }

                return name;
            }
        }
    };
</script>
